export const TOOLTIP_DELAY = 800;
export const ACTION_CUSTOM_BUTTON_CLICK = 'custom-button-click';
